<style scoped lang="scss">
  .wrap-primer{
    .top{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .title{
      h3{
        font-size: 24px;
        font-weight: bold;
      }
    }
    .el-steps{
      width:350px;
    }
    .address{
      background: #F9F9F9;
      padding:15px 20px;
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }
    .remark{
      background: #F9F9F9;
      padding:15px 20px;
      margin-top: 20px;
    }
  }
  .total{
    background: #F0F0F0;
    text-align: right;
    position: sticky;
    bottom:0;
    z-index: 5;
    span{
      margin-right:30px;
      display: inline-flex;
      align-items: center;
    }
    .price{
      font-weight: bold;
      font-size: 20px;
      color: #014492;
      small{
        font-size: 12px;
        font-weight: normal;
      }
    }
    .el-button{
      font-size: 20px;
      padding:14px 20px;
    }
  }
</style>
<template>
  <div class="wrap wrap-primer" v-loading="submitLoading">
    <section class="container">
      <div class="top">
        <div class="title">
          <h3>引物合成订单确认</h3>
          <div class="opera mt10">
            <span class="text-primary pointer mr20" @click="$router.push(`/tec/order_primer?id=${id}`)"><span class="el-icon-edit"></span> 编辑</span>
            <span class="text-primary pointer" @click="bindDelete" v-show="fromPage === 'order'"><span class="el-icon-delete"></span> 删除</span>
          </div>
        </div>
        <el-steps :active="1" align-center>
          <el-step title="录入引物基础信息"></el-step>
          <el-step title="确认订单"></el-step>
        </el-steps>
      </div>
      <qk-edit-address/>
      <div class="remark" v-show="remark">{{remark}}</div>
      <el-table
        class="mt20"
        border
        :data="primerLists">
        <el-table-column
          prop="name"
          label="引物名称">
        </el-table-column>
        <el-table-column
          prop="sequence"
          width="200px"
          label="引物序列">
        </el-table-column>
        <el-table-column
          prop="dsDna"
          label="碱基数">
        </el-table-column>
        <el-table-column
          prop="purificationWay"
          label="纯化方式">
        </el-table-column>
        <el-table-column
          prop="odNum"
          label="OD/管">
        </el-table-column>
        <el-table-column
          prop="fzNum"
          label="分装管数">
        </el-table-column>
        <el-table-column
          prop="modify5"
          label="5端修饰">
        </el-table-column>
        <el-table-column
          prop="modify3"
          label="3端修饰">
        </el-table-column>
        <el-table-column
          prop="modifyMid"
          label="中间修饰">
        </el-table-column>
        <el-table-column
          label="单价(元)">
          <template slot-scope="scope">
            <span v-if="scope.row.priceY">{{scope.row.priceY}}</span>
            <span v-else>待询价</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="total mt30">
        <span>总条数：{{primerLists.length}}</span>
        <span v-if="totalPrice !== '待询价'">结款后可得积分：{{integral ? integral : 0}}</span>
        <span v-if="totalPrice !== '待询价'">总金额：¥ {{totalPrice}}</span>
        <span v-else>总金额：{{totalPrice}}</span>
        <span v-if="totalPrice !== '待询价'">应付金额：<span class="price"><small>￥</small>{{totalPrice}}</span></span>
        <span v-else>应付金额：<span class="text-primary">{{totalPrice}}</span></span>
        <el-button type="primary" @click="onsubmit" v-preventReClick style="border-radius: 0;" :disabled="this.btnDisabled">确认并下单</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import { delPrimerOrder, primerOrderSubmit, primerOrderDetail, primerInfo,checkBlackList } from '@/services/api.index'
export default {
  data () {
    return {
      submitLoading: false,
      primerInfo: this.baseMethods.getLocalObj('primerInfo'),
      primerLists: [],
      remark: '',
      totalPrice: 0,
      id: this.$route.query.id,
      fromPage: this.$route.query.fromPage,
      integral: 0,
      btnDisabled: false
    }
  },
  created() {
    this.getDetails()
  },
  methods: {
    strip(num, precision = 12) {
      return +parseFloat(num.toPrecision(precision))
    },
    // 引物详情
    getDetails () {
      this.btnDisabled = true
      primerOrderDetail(this.id).then(res => {
        this.integral = res.data.value.integralNumber
        this.remark = res.data.value.remark
        this.totalPrice = res.data.value.amount / 100
        this.getPrimerLists()
      })
    },
    // 包含引物列表
    getPrimerLists () {
      this.primerLists = []
      primerInfo(this.id, 0, 500).then(res => {
        res.data.list.map((item, index) => {
          item.value.index = index + 1
          this.primerLists.push(item.value)
          if (!item.value.priceY) {
            this.totalPrice = '待询价'
          }
        })
        this.$nextTick(()=>{
           this.btnDisabled = false
        })
      })
    },
    async onsubmit () {
      
      let primerInfo = []
      const memberInfo = this.baseMethods.getLocalObj('memberInfo')
      const courseInfo = this.baseMethods.getLocalObj('courseInfo')
      let totalPrice = this.totalPrice === '待询价' ? 0 : this.totalPrice
      totalPrice = totalPrice * 100
      let sumbitData = {
        primerSynthesesSet: primerInfo,
        submitFlag: false,
        discountCoefficient: 1,
        // baseId: courseInfo.base.id,
        customerId: memberInfo.id,
        clientGrade: memberInfo.level,
        customerEmail: memberInfo.email,
        // researchTeamId: memberInfo.researchGroup.id,
        // serviceSalesId: memberInfo.serveSeller.id,
        amount: totalPrice,
        settlementAmount: totalPrice,
        remark: this.remark
      }
      //校验当前客户课题组是否被拉黑
      let {data}=await checkBlackList({customerId: memberInfo.id,type:"PRIMER"});     
      if(data==false){
        // this.$alert('下单异常，请联系销售人员','提示',{ confirmButtonText: '确认'})
        this.$alert('下单异常,请电联4006683730转7','提示',{ confirmButtonText: '确认'})        
        return;
      }
      this.submitLoading = true
      console.log(this.baseMethods.getRaAddress(), 666)
      sumbitData = Object.assign(sumbitData, this.baseMethods.getRaAddress())
      primerOrderSubmit(this.id, sumbitData).then(() => {
        this.submitLoading = false
        this.$message.success('下单成功')
        this.$router.push('/tec/success_submit?type=primer')
      })
    },
    // 删除
    bindDelete () {
      this.$confirm('确定删除此订单？', '提示', {
      }).then(() => {
        delPrimerOrder(this.id).then(() => {
          this.$message.success('删除成功')
          this.baseMethods.hrefUrl('/user/primer')
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/primer_confirm.vue